import { Box, makeStyles, TextField } from '@material-ui/core';
import { Pagination as MuiPagination, PaginationProps } from '@material-ui/lab';
import { clamp } from 'lodash';
import React, { useEffect, useState } from 'react';
import useDebounce from '../../hooks/useDebounce';

export type Props = Omit<PaginationProps, 'onChange'> & {
  onPageChange?: (newPage: number) => void;
};

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  pageInput: {
    paddingRight: spacing(4),
    width: 'auto',
  },
  muiPagination: {
    marginTop: 0,
  },
}));

const Pagination: React.FC<Props> = props => {
  const { count = 1, page = 1, onPageChange } = props;
  const styles = useStyles();

  const [inputValue, setInputValue] = useState(page);

  const onChangeDebounced = useDebounce((inputValue: number) => {
    onPageChange?.(inputValue);
  }, 1000);

  useEffect(() => {
    setInputValue(page);
  }, [page]);

  return (
    <Box className={styles.root}>
      {count > 1 && (
        <TextField
          placeholder={t('Page')}
          value={inputValue}
          variant="outlined"
          size="small"
          onBlur={e => {
            const newPage = Number((e.target as HTMLInputElement).value);
            onPageChange?.(clamp(newPage, 1, count));
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              const newPage = Number((e.target as HTMLInputElement).value);
              onPageChange?.(clamp(newPage, 1, count));
            }
          }}
          onChange={e => {
            const newPage = Number((e.target as HTMLInputElement).value);
            const clampedPage = clamp(newPage, 1, count);
            setInputValue(clampedPage);
            onChangeDebounced(clampedPage);
          }}
          fullWidth
          type="number"
          inputProps={{
            min: 1,
            max: count,
          }}
          className={styles.pageInput}
        />
      )}
      <MuiPagination
        {...props}
        classes={{ root: styles.muiPagination }}
        onChange={(_, newPageIndex) => onPageChange?.(newPageIndex)}
      />
    </Box>
  );
};

export default Pagination;
